import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=3c052812&scoped=true"
import script from "./Declaration.vue?vue&type=script&lang=js"
export * from "./Declaration.vue?vue&type=script&lang=js"
import style0 from "./Declaration.vue?vue&type=style&index=0&id=3c052812&prod&lang=css"
import style1 from "./Declaration.vue?vue&type=style&index=1&id=3c052812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c052812",
  null
  
)

export default component.exports